// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1s5bI","label":"Radio_label__31Ea-","checkMark":"Radio_checkMark__3yb03","disabled":"Radio_disabled__S-ZHR"};